import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { ServicoJornalService } from "src/app/services/servico-jornal.service";
import { obterArquivoServico, obterArquivoServicoFailure, obterArquivoServicoSuccess } from "../../actions/Servicos/obter-arquivo-servico-jornal.action";

@Injectable()
export class ObterArquivoServicoEffects {

  public obterArquivoServico$: unknown;

  constructor(private readonly actions$: Actions,
    private readonly servicoJornalService: ServicoJornalService) {
    this.createEffects()
  }

  private createEffects() {
     this.obterArquivoServico$ = createEffect(() => this.actions$.pipe(
       ofType(obterArquivoServico),
       switchMap(({ nomeArquivo }) =>
         this.servicoJornalService
           .obterArquivoServico(nomeArquivo)
           .pipe(
             map(
               response => {
               if (response.erros != undefined && response.erros.length > 0) {
                 return obterArquivoServicoFailure({ response })
               }
               return obterArquivoServicoSuccess({ response })
             }),
             catchError(() => {
               return of()}
             )
           )
       )
     )
     );
   }
}
